// ReviewsManagementPageService.ts
import axios from 'axios';
import { axiosRequest } from './AxiosService';
import { ReviewsManagementPageResponse, ReviewsManagementPageResponseList } from '../type/response/ReviewManagementPageResponse';
import { ReviewManagementPageType } from '../pages/ReviewManagement/data/ReviewManagementPageType';
import dayjs from 'dayjs';
import { group } from 'console';

/**
 * 審査管理ページデータを取得し、表示用の形式に変換して返す
 * @returns 審査管理一覧データ、取得失敗時は空配列
 */
export const getReviewManagementPageData = async (): Promise<ReviewManagementPageType[]> => {
  try {
    const response = await axiosRequest<ReviewsManagementPageResponseList>(
      "/reviewsManagementPage",
      "GET"
    );

    if (!Array.isArray(response)) {
      console.error("予期しないAPIレスポンス形式です:", response);
      return [];
    }

    // サーバーから取得したデータのフォーマットを変更する
    const formattedReviews: ReviewManagementPageType[] = response.map((reviewManagementPageResponse: ReviewsManagementPageResponse) => {
      const formattedReview: ReviewManagementPageType = {
        id: reviewManagementPageResponse.applicationEntry.id,
        applicationNumber: reviewManagementPageResponse.applicationEntry.number,
        submittedAt: reviewManagementPageResponse.applicationEntry.submittedAt,  // 申請日
        applicationType: reviewManagementPageResponse.applicationType.name || "", // 申請種別
        applicationFormat: reviewManagementPageResponse.application.name || "", // 申請書
        description: reviewManagementPageResponse.application.description || "", // 申請書小分類
        applicationStatus: reviewManagementPageResponse.applicationEntry.status, // ステータス
        groups: Array.isArray(reviewManagementPageResponse.groups)//所属グループ
          ? reviewManagementPageResponse.groups.map(group => group.name)
          : [],
        applicant: `${reviewManagementPageResponse.user.lastName}${reviewManagementPageResponse.user.firstName}`, // 申請者
        isUrgent: reviewManagementPageResponse.applicationEntry.isExpress, // 急ぎ申請か否か
        userProfiles: Array.isArray(reviewManagementPageResponse.userProfiles) //ユーザプロファイル
          ? reviewManagementPageResponse.userProfiles.map(profile => ({
            key: profile.key,
            value: profile.value
          })) : [],
        activities: Array.isArray(reviewManagementPageResponse.activities)
          ? reviewManagementPageResponse.activities.map(act => ({
            id: act.id,
            activityStatus: act.status,
            activityName: act.applicationActivity.activityName,
            endAt: act.endAt,
            order: act.applicationActivity.activityOrder,
            code: act.applicationActivity.code,
            approverIds: act.approverIds ?? [],
            approvedIds: act.approvedIds ?? []
          }))
          : []
      };

      return formattedReview;
    });

    return formattedReviews;

  } catch (error) {
    console.error("審査管理ページデータの取得・整形に失敗しました:", error);
    return [];
  }
};